module.exports = __webpack_public_path__ + "img/car_shina2_22.2151fbe4.jpg";